import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const fields = [
  { k: "parent_name", label: "Nama Pemesan / Orang Tua", ph: "cth. Budi Santoso" },
  { k: "whatsapp", label: "Nomor WhatsApp", ph: "08xxxxxxxxxx", type: "tel" },
  { k: "athlete_name", label: "Nama Atlet", ph: "cth. Rafi Santoso" },
  { k: "bib_number", label: "Nomor BIB", ph: "cth. 127" },
  { k: "club", label: "Klub / Asal Kota", ph: "cth. Surabaya Inline Club" },
  { k: "category", label: "Kelompok Umur / Kategori", ph: "cth. KU 10-12 Putra" },
];

export const SectionTitle = ({ n, children }) => (
  <div className="flex items-center gap-3 mb-5">
    <span className="font-display font-black text-xl bg-[#FF5A00] w-9 h-9 flex items-center justify-center">{n}</span>
    <h2 className="font-display font-extrabold uppercase text-2xl">{children}</h2>
  </div>
);

export default function AthleteFields({ form, setForm }) {
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <section>
      <SectionTitle n="1">Data Pemesan & Atlet</SectionTitle>
      <div className="grid sm:grid-cols-2 gap-4">
        {fields.map((f) => (
          <div key={f.k} className="space-y-2">
            <Label htmlFor={f.k}>{f.label}</Label>
            <Input id={f.k} required type={f.type || "text"} placeholder={f.ph} value={form[f.k]} onChange={set(f.k)} data-testid={`order-${f.k}-input`} className="h-12 bg-[#121212]" />
          </div>
        ))}
        <div className="space-y-2 sm:col-span-2">
          <Label htmlFor="notes">Catatan (opsional)</Label>
          <Textarea id="notes" placeholder="Catatan tambahan untuk tim kami" value={form.notes} onChange={set("notes")} data-testid="order-notes-input" className="bg-[#121212]" />
        </div>
      </div>
    </section>
  );
}
